export default __webpack_public_path__ + "locales/de/Payments.json?hash=a294a1ec9410f1fff36819ed3401a480";